import { render, staticRenderFns } from "./vue-text-scroll.vue?vue&type=template&id=78f12b57&scoped=true&"
import script from "./vue-text-scroll.vue?vue&type=script&lang=js&"
export * from "./vue-text-scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f12b57",
  null
  
)

export default component.exports